import { Box, Grid, SlideFade } from '@chakra-ui/react'
import { useContext } from 'react'
import { SubProps, SubWrapperProps } from './types'
import { NavigationContext } from './Navigation'

const Sub = ({
  YOffset = 0,
  YOffsetStart = 4,
  className,
  theme = 'brand',
  children,
  ...props
}: SubProps) => {
  const { isOpen } = useContext(NavigationContext)
  return (
    <Box position='relative'>
      <SlideFade
        in={isOpen}
        offsetY={`-${YOffsetStart}rem`}
        transition={{ enter: { duration: 0.3, delay: 0.2 } }}
      >
        <Grid
          className={className}
          margin='auto'
          templateColumns='repeat(12, 1fr)'
          gap={6}
          p={6}
          w='100%'
          backgroundColor={`${theme}.bg.secondary`}
          textColor={`${theme}.text.primary`}
          transform={`translateY(-${YOffset}rem)`}
          {...props}
        >
          {children}
        </Grid>
      </SlideFade>
    </Box>
  )
}

export const SubWrapper = ({ subKey, children, ...props }: SubWrapperProps) => {
  const { activeIndex } = useContext(NavigationContext)

  return (
    <Box display={activeIndex === subKey ? 'block' : 'none'} {...props}>
      {children}
    </Box>
  )
}

export default Sub
